import FEATURE_CONFIG from 'constants/features';
import { getCountryCode } from './locales';

export * from 'constants/features';

export function isFeatureEnabled(featureName, storeCode = getCountryCode()) {
  return FEATURE_CONFIG[storeCode.toUpperCase()]?.includes(featureName);
}
